/// <reference types="grecaptcha" preserve="true"/>

export { RecaptchaComponent, RecaptchaErrorParameters } from "./lib/recaptcha.component";
export { RecaptchaLoaderService } from "./lib/recaptcha-loader.service";
export { RecaptchaModule } from "./lib/recaptcha.module";
export { RecaptchaSettings } from "./lib/recaptcha-settings";

export { RecaptchaV3Module } from "./lib/recaptcha-v3.module";
export { OnExecuteData, OnExecuteErrorData, ReCaptchaV3Service } from "./lib/recaptcha-v3.service";

export { RecaptchaFormsModule } from "./lib/recaptcha-forms.module";
export { RecaptchaValueAccessorDirective } from "./lib/recaptcha-value-accessor.directive";

export {
  // eslint-disable-next-line deprecation/deprecation
  RECAPTCHA_LANGUAGE,
  // eslint-disable-next-line deprecation/deprecation
  RECAPTCHA_BASE_URL,
  // eslint-disable-next-line deprecation/deprecation
  RECAPTCHA_NONCE,
  RECAPTCHA_SETTINGS,
  RECAPTCHA_V3_SITE_KEY,
  RECAPTCHA_LOADER_OPTIONS,
  RecaptchaLoaderOptions,
} from "./lib/tokens";
